import { useMemo } from 'react';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useRouterFilters from 'hooks/useRouterFilters';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ShipmentErrorLogsByAiList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'ID',
				filterType: FilterType.number,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				showCopyButton: true
			},
			{
				Header: 'companyID',
				accessor: 'companyId',
				filterType: FilterType.string,
				showCopyButton: true
			},
			{
				Header: 'otoOrderId',
				accessor: 'otoOrderId',
				filterType: FilterType.number,
				showCopyButton: true
			},
			{
				Header: 'deliveryCompany',
				accessor: 'deliveryCompany',
				filterType: FilterType.string
			},
			{
				Header: 'agreementType',
				accessor: 'agreementType',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.SHIPPING_PRICE_AGREEMENT_TYPE
			},
			{
				Header: 'url',
				accessor: 'URL',
				filterType: FilterType.string
			},
			{
				Header: 'requestJSON',
				accessor: 'requestJSON',
				filterType: FilterType.string
			},
			{
				Header: 'dcSettingsId',
				accessor: 'dcSettingsId',
				filterType: FilterType.string
			},
			{
				Header: 'response',
				accessor: 'response',
				filterType: FilterType.string
			},
			{
				Header: 'errorText',
				accessor: 'errorText',
				filterType: FilterType.string
			},
			{
				Header: 'method',
				accessor: 'method',
				filterType: FilterType.string
			},
			{
				Header: 'errorTime',
				accessor: 'errorTime',
				filterType: FilterType.date,
				show: true,
				renderCell: ListComponents.DATETIME,
				customFilterOptions: [FilterAction.between, FilterAction.on]
			},
			{
				Header: 'aiErrorId',
				accessor: 'aiErrorId',
				filterType: FilterType.number
			},
			{
				Header: 'customerName',
				accessor: 'customerName',
				filterType: FilterType.string
			},
			{
				Header: 'recipientFirstname',
				accessor: 'recipientFirstname',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientMiddlename',
				accessor: 'recipientMiddlename',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientLastname',
				accessor: 'recipientLastname',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientDistrict',
				accessor: 'recipientDistrict',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientRegion',
				accessor: 'recipientRegion',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientState',
				accessor: 'recipientState',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientCity',
				accessor: 'recipientCity',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientCountry',
				accessor: 'recipientCountry',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				showOnMobile: true,
				show: false
			},
			{
				Header: 'recipientPhone',
				accessor: 'recipientPhone',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientPostcode',
				accessor: 'recipientPostcode',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientEmail',
				accessor: 'recipientEmail',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientLat',
				accessor: 'recipientLat',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientLon',
				accessor: 'recipientLon',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientBuildingName',
				accessor: 'recipientBuildingName',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientStreet',
				accessor: 'recipientStreet',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientNearestLandmark',
				accessor: 'recipientNearestLandmark',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientW3W',
				accessor: 'recipientW3W',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientRefID',
				accessor: 'recipientRefID',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientAddress',
				accessor: 'recipientAddress',
				filterType: FilterType.string,
				show: false
			},
			{
				Header: 'recipientNeighbourhood',
				accessor: 'recipientNeighbourhood',
				filterType: FilterType.string,
				show: false
			}
		],
		[]
	);

	const filtersFromRouter = useRouterFilters(columns);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.SHIPMENT_ERROR_LOGS_BY_AI}
				columns={columns}
				defaultSort={defaultSort}
				defaultFilters={filtersFromRouter}
				fetchUrl={ADMIN.GET_SHIPMENT_ERROR_LOGS_BY_AI}
				exportName="shipmentErrorLogsByAiMapping"
				infiniteScroll
			/>
		</TabTableContainer>
	);
};

export default ShipmentErrorLogsByAiList;
